import { render } from "./CryptosCreep3d.vue?vue&type=template&id=1d85a0dd&scoped=true"
import script from "./CryptosCreep3d.vue?vue&type=script&lang=js"
export * from "./CryptosCreep3d.vue?vue&type=script&lang=js"

import "./CryptosCreep3d.vue?vue&type=style&index=0&id=1d85a0dd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d85a0dd"]])

export default __exports__